import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

export function useOrgFileTags(orgId?: string) {
  const { currentOrganization } = useAuth();
  const canonicalOrgId = orgId || currentOrganization?.org_id;
  const { files: fileService } = useDomainServices();

  return useQuery<string[], Error>({
    queryKey: ["orgFileTags", canonicalOrgId],
    queryFn: ({ signal }) => {
      if (canonicalOrgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }

      return fileService.getTagsForOrg({
        abortSignal: signal,
        resourceOwnerId: canonicalOrgId,
      });
    },
    enabled: canonicalOrgId !== undefined,
    staleTime: 30000,
  });
}
